const rooster = {
  outerWrapper: {
    position: 'relative',
  },
  fromPatient: {
    position: 'relative',
    fontSize: '0.8em',
    display: 'table',
    width: 'auto',
    minWidth: '150px',
    maxWidth: '400px',
    backgroundColor: '#e6e6e6',
    margin: '15px 1px 1px 1px',
    textAlign: 'left',
    left: '60px',
    padding: '6px 10px 6px 10px',
    borderRadius: '10px',
  },
  currentUser: {
    position: 'relative',
    fontSize: '0.8em',
    display: 'table',
    fontWeight: 100,
    width: 'auto',
    minWidth: '150px',
    maxWidth: '400px',
    backgroundColor: '#673ab7',
    color: 'white',
    margin: '15px 1px 1px 1px',
    textAlign: 'left',
    marginLeft: 'auto',
    right: '60px',
    padding: '6px 10px 6px 10px',
    borderRadius: '10px',
  },
  currentUser_time: {
    position: 'absolute',
    fontSize: '0.6em',
    right: '2px',
    width: '56px',
    textAlign: 'left',
    padding: '4px',
    bottom: 0,
    color: '#595959',
    whiteSpace: 'pre-line',
  },
  fromPatient_time: {
    position: 'absolute',
    fontSize: '0.6em',
    padding: '4px',
    bottom: 0,
    width: '56px',
    textAlign: 'right',
    color: '#595959',
    whiteSpace: 'pre-line',
  },
}

const tops = {
  outerWrapper: {
    position: 'relative',
  },
  fromPatient: {
    position: 'relative',
    fontSize: '0.8em',
    display: 'table',
    width: 'auto',
    minWidth: '150px',
    maxWidth: '400px',
    backgroundColor: '#e6e6e6',
    margin: '15px 1px 1px 1px',
    textAlign: 'left',
    left: '60px',
    padding: '6px 10px 6px 10px',
    borderRadius: '10px',
  },
  currentUser: {
    position: 'relative',
    fontSize: '0.8em',
    display: 'table',
    fontWeight: 100,
    width: 'auto',
    minWidth: '150px',
    maxWidth: '400px',
    backgroundColor: '#0091EA',
    color: 'white',
    margin: '15px 1px 1px 1px',
    textAlign: 'left',
    marginLeft: 'auto',
    right: '60px',
    padding: '6px 10px 6px 10px',
    borderRadius: '10px',
  },
  currentUser_time: {
    position: 'absolute',
    fontSize: '0.6em',
    right: '2px',
    width: '56px',
    textAlign: 'left',
    padding: '4px',
    bottom: 0,
    color: 'black',
    whiteSpace: 'pre-line',
  },
  fromPatient_time: {
    position: 'absolute',
    fontSize: '0.6em',
    padding: '4px',
    bottom: 0,
    width: '56px',
    textAlign: 'right',
    color: 'black',
    whiteSpace: 'pre-line',
  },
}

module.exports = process.env.REACT_APP_IS_TOPS ?
  tops :
  rooster



// WEBPACK FOOTER //
// ./src/components/Messages/styles/Text.js